import React from "react";
import {IconButton} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

type Props = {
  onClick: (event: any) => void
}

export default function DeleteButton({onClick}: Props) {
  return (
    <IconButton onClick={onClick}>
      <DeleteIcon />
    </IconButton>
  )
}